import { t } from '@lingui/macro';

export type GradeTitleValue = 0 | 1 | 2 | 3 | 4 | 5;

export const selectTitleGrade = (value: GradeTitleValue = 0) => {
  return {
    0: t`Оценка отсутствует`,
    1: t`Очень плохо`,
    2: t`Плохо`,
    3: t`Удовлетворительно`,
    4: t`Хорошо`,
    5: t`Отлично`,
  }[value];
};
